var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn17(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,8a7.67,7.67,0,0,0-6,2.89A7.67,7.67,0,0,0,29,8H6.47V52.59H29a4.33,4.33,0,0,1,4.33,4.33h3.34A4.33,4.33,0,0,1,41,52.59h2.52v5.54A3.88,3.88,0,0,0,47.4,62h2.06a3.88,3.88,0,0,0,3.88-3.87V52.59H63.53V8ZM33.33,50.58A7.68,7.68,0,0,0,29,49.24H9.81V45.9H29a4.33,4.33,0,0,1,4.33,4.33Zm0-6.68A7.6,7.6,0,0,0,29,42.56H9.81V11.34H29a4.33,4.33,0,0,1,4.33,4.33Zm10.19,5.34H41a7.68,7.68,0,0,0-4.33,1.34v-.35A4.33,4.33,0,0,1,41,45.9h2.52ZM50,58.13a.53.53,0,0,1-.53.53H47.4a.53.53,0,0,1-.53-.53v-2H50Zm0-5.3H46.87V34.77H50ZM47,31.42l1.44-2,1.44,2Zm13.2,17.82H53.34V45.9h6.85Zm0-6.68H53.34v-12L50.1,26.05v-2.5H46.76v2.5l-3.24,4.46V42.56H41a7.6,7.6,0,0,0-4.33,1.34V15.67A4.33,4.33,0,0,1,41,11.34H60.19ZM13.32,15.24h16.5v3.35H13.32Zm0,20.07H24.25v3.34H13.32Zm0-6.69h16.5V32H13.32Zm16.5-6.69v3.35H25.36V21.93ZM22,25.28h-8.7V21.93H22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn17);
export default __webpack_public_path__ + "static/media/icn_17.fb171260d32729887c84865d06f04487.svg";
export { ForwardRef as ReactComponent };